(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/coupon.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/coupon.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  const constants = svs.maltipset.constants;
  svs.maltipset.views.Coupon = Marionette.View.extend({
    regions: {
      couponHeader: '.coupon-header',
      matchList: '.maltipset-match-list',
      board: '.maltipset-board',
      drawSelector: '#drawChooser',
      header: '.maltipset-matchlist-head',
      betslip: '#betslip-wrapper'
    },
    modelEvents: {
      'xpert:startLoad': 'xpertStarLoad',
      'xpert:doneLoad': 'xpertDoneLoad',
      'xpert:error': 'xpertError',
      'wager:payError': 'paymentError',
      'wager:paySuccess': 'paymentSuccess',
      'change:system createBaseRow stopBaseRowEdit': 'columnChange',
      'change:hasMarkedMatches': 'updateContextMenu',
      'change:actionBar change:system': 'showActionBar',
      'change:totalSelectedMatches': 'updateActionBar'
    },
    ui: {
      matches_cols: '#js-matches-cols',
      board_container: '.maltipset-board-container',
      matclist_board_container: '.matchlist-board-container'
    },
    log: new svs.core.log.Logger('svs.maltipset.views.Coupon'),
    AUTHENTICATED_SAM_NOT_ASM: 3107,
    NOT_AUTHENTICATED: 100005,
    SALES_STOPPED: 8124,
    REG_BET_REJECTED_DRAW_CLOSED: 8105,
    REG_BET_REJECTED_DRAW_NOT_OPEN: 8107,
    template(data) {
      return svs.maltipset.templates.coupon(data);
    },
    initialize() {
      if (!svs.core.detect.formfactor.mobile()) {
        this.addRegion('betslipOverview', '#maltipset-slider-folder');
      }
      this.bindUIElements();
    },
    onAttach() {
      this.getRegion('matchList').show(new svs.maltipset.views.MatchList({
        collection: this.model.get('draw').get('matchList')
      }));
      this.createBoardView();
      this.getRegion('couponHeader').show(new svs.maltipset.views.CouponHeader({
        model: this.model
      }));
      svs.maltipset.controllers.maltipsetController.initContextMenu({
        isStartPage: false,
        system: this.model.get('system'),
        showMenuInHeader: false,
        enableClearAll: _.filter(svs.maltipset.models.storageCoupon.get('selectedMatches'), arr => arr.length).length > 0
      });
      this.showActionBar();
      if (!svs.core.detect.formfactor.mobile()) {
        svs.maltipset.views.betslipOverview = undefined;
        svs.maltipset.views.betslipOverview = new svs.maltipset.views.BetslipOverview({
          coupon: this.model
        });
        this.getRegion('betslipOverview').show(svs.maltipset.views.betslipOverview);
      }
    },
    onRender() {
      this.setBoardColumns();
      this.addDrawSelector();
    },
    setBoardColumns() {
      this.ui.matches_cols.removeClass();
      this.ui.board_container.attr('class', 'maltipset-board-container');
      if (this.model.get('xpertBaseRowMode')) {
        this.ui.matches_cols.addClass('col-xs-8');
        this.ui.board_container.addClass('xpert-base-row col-xs-4');
      } else if (!this.model.isMOrRSystem()) {
        this.ui.matches_cols.addClass('col-xs-6 col-md-4');
        this.ui.board_container.addClass('col-xs-6 col-md-8');
      } else {
        this.ui.matches_cols.addClass('col-xs-8');
        this.ui.board_container.addClass('system-active col-xs-4');
      }
      this.ui.matclist_board_container.toggleClass('sticky-padding-top', false);
    },
    createBoardView() {
      if (this.boardView) {
        this.boardView.close();
      }
      this.boardView = new svs.maltipset.views.Board({
        collection: this.model.get('board'),
        coupon: this.model
      });
      this.getRegion('board').show(this.boardView);
    },
    columnChange() {
      if (svs.maltipset.views.betslip) {
        svs.maltipset.views.betslip.setWidth();
      }
      this.setBoardColumns();
      this.createBoardView();
    },
    showActionBar() {
      switch (this.model.get('actionBar')) {
        case constants.ACTIONBARS.SYSTEM:
          this.systemShow();
          break;
        case constants.ACTIONBARS.XPERT:
          this.xpertShow();
          break;
        case constants.ACTIONBARS.BASEROW:
          this.showBaseRowActionBar();
          break;
        case constants.ACTIONBARS.NO_BAR:
          svs.sport.actionbar.hide();
          break;
        default:
      }
      svs.sport.actionbar.reposition();
    },
    systemShow() {
      if (this.model.isMOrRSystem()) {
        const coupon = this.model;
        const system = this.model.get('system') === constants.SYSTEM.M_SYSTEM ? 'M-System' : 'R-System';
        const options = {
          leftButton: {
            type: svs.core.detect.formfactor.mobile() ? 'button' : 'text',
            text: "<span class=\"padding-sm-right\">".concat(system, "</span>"),
            visible: true,
            disabled: !svs.core.detect.formfactor.mobile(),
            callback() {
              svs.maltipset.controllers.maltipsetController.showSystemspel();
            }
          },
          centerButton: {
            type: 'link',
            text: '',
            icon: 'icon-default icon-300 icon-dustbin',
            visible: true,
            callback() {
              svs.maltipset.controllers.maltipsetController.convertSystem(constants.SYSTEM.NO_SYSTEM);
            }
          }
        };
        _.defer(() => {
          svs.sport.actionbar.show(options, coupon);
        });
      } else {
        this.model.removeActionbar();
      }
    },
    updateContextMenu() {
      svs.maltipset.controllers.maltipsetController.initContextMenu({
        isStartPage: false,
        showMenuInHeader: false,
        system: this.model.get('system'),
        enableClearAll: this.model.get('hasMarkedMatches')
      });
    },
    updateActionBar() {
      if (this.model.get('actionBar') === constants.ACTIONBARS.BASEROW) {
        this.showBaseRowActionBar();
      }
    },
    showBaseRowActionBar() {
      let actionBar;
      const self = this;
      svs.sport.actionbar.show({
        leftButton: {
          type: 'text',
          text: this.model.get('matchesLeftToMaxSelect') > 0 ? 'Välj de matcher du vill ha som säkra' : 'Detta system tillåter inte fler makeringar som grundrad',
          visible: true
        },
        rightButton: {
          type: 'link',
          text: '',
          icon: 'icon-default icon-300 icon-dustbin',
          visible: true,
          callback() {
            self.model.stopBaseRowEdit();
          }
        },
        bottomView: {
          text: 'Gör minst en markering och lämna minst en match omarkerad'
        },
        bottomButton: {
          type: 'button',
          text: 'Generera rader',
          visible: true,
          disabled: this.model.get('totalSelectedMatches') === 0,
          callback() {
            this.model.newXpert(true);
          }
        }
      }, this);
      setTimeout(() => {
        actionBar = document.getElementsByClassName('actionbar')[0];
        if (actionBar) {
          actionBar.classList.add('actionbar-clear-bottom-border');
        }
      });
    },
    xpertShow() {
      this.createBoardView();
      const coupon = this.model;
      let currentSystem = null;
      if (this.model.isMOrRSystem()) {
        currentSystem = this.model.get('system') === constants.SYSTEM.M_SYSTEM ? 'M' : 'R';
      }
      const options = {
        leftButton: {
          type: svs.core.detect.formfactor.mobile() ? 'button' : 'text',
          text: !currentSystem ? "PIX! ".concat(coupon.get('totalCompleteRows'), " rader") : "PIX! ".concat(currentSystem, " ").concat(coupon.get('numberOfSelectedMatches')),
          disabled: !svs.core.detect.formfactor.mobile(),
          visible: true,
          callback() {
            svs.maltipset.controllers.maltipsetController.showXperten();
            return true;
          }
        },
        centerButton: {
          type: 'button',
          icon: 'icon-default icon-300 icon-refresh',
          visible: true,
          callback() {
            this.newXpert(!_.isUndefined(this.get('baseRow')));
            return true;
          }
        },
        rightButton: {
          type: 'link',
          text: '',
          icon: 'icon-default icon-300 icon-dustbin',
          visible: true,
          callback() {
            this.empty(true);
          }
        }
      };
      svs.sport.actionbar.show(options, coupon);
    },
    xpertError(response) {
      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'help-2',
        title: 'Det går tyvärr inte att spela på PIX!',
        actions: [{
          title: 'Okej'
        }]
      }));
      this.log.debug("Error getting xpert: ".concat(response.status, ": ").concat(response.statusText));
    },
    xpertStarLoad() {
      svs.components.loader.show();
    },
    xpertDoneLoad() {
      svs.components.loader.hide();
    },
    paymentSuccess() {
      this.model.changeSystem(constants.SYSTEM.NO_SYSTEM);
      let url = '';
      const afterGameTab = 'relaterat';
      const hasRelatedTab = svs.maltipset.data.config.startPageConfig.tabs.some(tab => tab.anchor === afterGameTab && tab.active === true);
      if (hasRelatedTab) {
        url = "?flik=".concat(afterGameTab);
      }
      svs.maltipset.router.navigate(url, {
        trigger: true
      });
    },
    paymentError(response) {
      const errCodestr = String(response.error.code);
      const errCode = parseInt(errCodestr.replace(/\s/g, ''), 10);
      let errMessage;
      let errTitle;
      switch (errCode) {
        case this.AUTHENTICATED_SAM_NOT_ASM:
          svs.core.userSession.logout();
          errTitle = 'Du måste logga in först.';
          break;
        case this.NOT_AUTHENTICATED:
          errTitle = 'Du måste logga in först.';
          break;
        case this.SALES_STOPPED:
          errTitle = 'Omgången är stängd för spel, vänligen försök senare';
          break;
        case this.REG_BET_REJECTED_DRAW_CLOSED:
          errTitle = 'Omgången har stängt';
          break;
        case this.REG_BET_REJECTED_DRAW_NOT_OPEN:
          errTitle = 'Omgången har inte öppnat för spel, vänligen försök senare';
          break;
        default:
      }
      svs.sport.sport_common.showErrorDialog(errTitle, errMessage);
      this.log.debug("Error in payment: ".concat(response.error.code, ": ").concat(response.error.message));
    },
    addDrawSelector() {
      const drawselectorOptions = {
        callback(drawNum) {
          Backbone.history.navigate("/".concat(drawNum), {
            trigger: true,
            replace: true
          });
        },
        draws: svs.maltipset.collections.draws.getAllDraws(),
        currentDraw: svs.maltipset.collections.coupons.getCurrentCoupon().get('draw').get('drawNumber'),
        branding: 'maltipset',
        swiperUpdateFunction: this.updateSwiper
      };
      this.getRegion('drawSelector').show(new svs.sport.drawselector.views.Drawselector(drawselectorOptions));
    }
  });
})(Backbone, _, svs);

 })(window);